import { ErrorBanner, WarningBanner } from 'ui/banner';
import styled from 'styled-components';

const StyledErrorBanner = styled(ErrorBanner)`
width: 100%;
`;

const StyledWarningBanner = styled(WarningBanner)`
width: 100%;
`;

export const HoldUntilReplyUnsortedRepliesBanner = () => (
  <StyledErrorBanner title="Could not sort replies">
    The number of replies in each locale doesn't match. Drag a reply or select several at once to
    sort them manually, or start with auto-sort and make changes as needed.
  </StyledErrorBanner>
);

export const HoldUntilReplyCheckQuickReplyGroupsBanner = () => (
  <StyledWarningBanner title="Action needed: Check quick reply groups">
    Please drag and drop your quick replies into reply groups.
  </StyledWarningBanner>
);
